import React, { useState, useEffect } from 'react';
import './ReportsModal.css';
import * as Yup from 'yup';
import Form from '../../form/components/Form/Form';
import FormField from '../../form/components/FormField/FormField';
import Button from '../../form/components/Button/Button';
import ErrorMessage from '../../form/components/ErrorMessage/ErrorMessage';
import { ImCancelCircle } from 'react-icons/im';
import { FaCloudUploadAlt, FaTrashAlt } from  'react-icons/fa';
import { useRef } from 'react';
import { toast } from 'react-toastify';
import BeatLoader from "react-spinners/BeatLoader";
import ProgressBar from '../../Progress/Progress';
import moment from 'moment';
import { auth } from '../../../firebase/firebase-config';
import { doc, collection, getDoc, updateDoc, arrayUnion   } from "firebase/firestore"; 
import { getStorage,  ref, uploadBytesResumable, getDownloadURL, deleteObject} from 'firebase/storage';

import { firebaseApp,  } from '../../../utils/firebaseConfig';
import { useAuthState } from 'react-firebase-hooks/auth';
import { db } from "../../../firebase/firebase-config";

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const initialValues= {
    case_id: '',
}

const override = {
    marginTop: '20px'
  };



function ReportsModal({ onClose, onContentAdded } : any) {
    const [error, setError] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const currentDate = moment();
    const [user] = useAuthState(auth);

    // REPORT PDF
    const [reportPdfUrl, setReportPdfUrl] = useState<any>('');
    const [reportsPdfProgress,  setReportPdfProgress] = useState(0);
    const [isUploadingSolutionPdf, setIsUploadingReportPdf] = useState(false);

    // END OF ASSIGNEMTN
    const storage = getStorage(firebaseApp);
    

    // good
    const solutionFileRef: any = useRef(null);

    const validationSchema = Yup.object().shape({
        case_id: Yup.string(),
    })

    const uploadReportPdf = (e: any) => {
        setIsUploadingReportPdf(true);
      const pdfFile: any = e.target.files[0];
      const storageRef = ref(storage, `pdf/${Date.now()}-${pdfFile.name}`);
      const uploadTask = uploadBytesResumable(storageRef, pdfFile);

      console.log(e.target.files[0]);   
  
    uploadTask.on('state_changed', (snapshot: any)=>{
        const uploadProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

        setReportPdfProgress(+uploadProgress);

    }, (error: any) => {
        console.log(error);
    },()=> {
         getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            setReportPdfUrl(downloadURL);
            setIsUploadingReportPdf(false);
        });
    })
  }




    const handleSubmitReport = async (values: any) => {

            const formattedDate = currentDate.format('YYYY-MM-DD');
            // const cityRef = doc(firebaseApp, 'Cases', values.case_id);
            setLoading(true);
            let data = {    
                ...values,
                document_url: reportPdfUrl,
            }

            if(reportPdfUrl?.length < 2) {
                toast.error("Report File Needed", {
                    pauseOnHover: false,
                    closeOnClick: true,
                })
                setLoading(false);
                return;
            }

            const reqData = {
                owner: user?.displayName,
                file_url: reportPdfUrl,
                created_at: formattedDate
            }

           try {
            const docRef = doc(db,"Cases", values.case_id.trim())
    
            // Update the document with the modified array
            await updateDoc(docRef, {
                reports: arrayUnion(reqData),
            });

            setLoading(false);
            onClose();
            toast.success('Report Created', {
                pauseOnHover: false,
                closeOnClick: true,
            })
            

           } catch (error) {
            setLoading(false);
            toast.error("ERROR", {
                pauseOnHover: false,
                closeOnClick: true,
            })
           }
    }



    
    return (
        <div>
            <div  className='modal-container student-modal-assignment' id="reports-modal">
                <div className='modal-head'>
                    <p className="modal-title">Upload Report</p>
                    <ImCancelCircle style={{cursor: 'pointer'}} onClick={onClose} size={22} color="#fff"/>
                </div>
                <div className='modal-content'>
                <div style={{textAlign: 'center', marginBottom: '10px'}}>
                    <BeatLoader
                        color="#3080ED" 
                        loading={loading}
                        cssOverride={override}
                    />
                </div>
                <form action="" className="auth-form">

                {error && <ErrorMessage error={error} visible={true} />}
                <Form 
                    initialValues={initialValues}
                    onSubmit={handleSubmitReport}
                    validationSchema={validationSchema}
                >
    

                        <p className="label-text">Case ID: </p>
                        <FormField  name="case_id" type="text" placeholder="Enter Case Id"/>

 
                        <div className='upload-content-container'>

                          {reportPdfUrl?.length < 2 &&  <div className="form-field-upload content-upload-right">
                            <p className="label-text">Upload Report Pdf: </p>
                            <div className="file-drop-upload" onClick={() => solutionFileRef.current.click()}>
                            {!isUploadingSolutionPdf && <FaCloudUploadAlt size={35} color="#FFA500" />}
                                <input ref={solutionFileRef} onChange={uploadReportPdf} type="file" style={{width: '100%', height: '100%', display: 'none'}} accept="application/pdf,application/vnd.ms-excel"/>
                                {isUploadingSolutionPdf &&  <div style={{width: '80%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                              <BeatLoader
                                    color="#3080ED" 
                                    loading={isUploadingSolutionPdf}
                                    cssOverride={override}
                                />
                                <p style={{fontSize: '14px'}}>Uploading Content</p>
                            
                                    <ProgressBar bgcolor={'#6a1b9a'} completed={reportsPdfProgress}/>
                                
                              </div>}
                        
                            </div>
                        </div>}

                        {reportPdfUrl.length > 2 &&
                            <div className="form-field-upload content-upload-right">
                            <p className="label-text" style={{textAlign: 'center'}}>Done</p>
                            </div>
                            }
                        </div>
               
                      {!loading && <Button isOutLined={true} isFullWidth={false} title="SUBMIT REPORT"/>}

                        </Form>
                </form>
                </div>
            </div>
            <div className="modal-shadow" onClick={onClose}>
               
            </div>
        </div>
    );
}

export default ReportsModal;
